import React, { Component } from 'react';
import swal from 'sweetalert';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { connect } from 'react-redux';
import { Switch } from '@progress/kendo-react-inputs';
import { fetchStates } from '../../../../../Redux/Actions/CommonActions';
import {
	fetchMembershipUsersByUser,
} from '../../../../../Redux/Actions/Admin/ManageMembershipUserActions';
import {
	getUserCommittees,
} from '../../../../../Redux/Actions/EndUser/AccountDetailsActions';

class MembershipUserForm extends Component {
	constructor(props) {
        super(props);
		this.state = {
			membershipUsersDetails: [],
		};
	}

    componentDidMount() {
		this.props.fetchMembershipUsersByUser(this.props.userId, this.props.membershipAssignmentId);
		this.props.getUserCommittees(this.props.userId);
		this.props.fetchStates();
	}

    componentWillUpdate(nextProps, nextState) {
		if(this.props.membershipUsersDetails !== nextProps.membershipUsersDetails){
			this.setState({membershipUsersDetails: nextProps.membershipUsersDetails})
		}
	}

	isCustom(item) {
		return item.id === undefined;
	}
	addKey(item) {
		item.id = new Date().getTime();
	}
	onDialogInputChange = (event) => {
		let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.membershipUserInEdit;
		edited[name] = value;
		edited.isActive = true;
		this.setState({
			membershipUserInEdit: edited
		});
	};

	handleSubmit = (event) => {
		event.preventDefault();
		this.props.cancel();
	}

	render() {
		console.log("render userCommittees", this.props.membershipUsersDetails);
		const membershipUser = this.props.membershipUsersDetails.length !== 0 ? this.props.membershipUsersDetails[0]:[];
		return (
			<Dialog onClose={this.props.cancel}>
				<h2 className="adjust-title">Membership User Information</h2>{
				<form className="user-form" onSubmit={this.handleSubmit}>
					<div className="form-group col-md-6 col-lg-6">
						<h3 className="highlight">User Information</h3>
						<ul>
							<li className="">
								<b>First Name:</b> {membershipUser.firstName}
							</li>
							<br></br>
							<li>
								<b>Last Name:</b> {membershipUser.lastName}
								</li>
							<br></br>
							<li>
								<b>Email:</b> {membershipUser.email}
							</li>
							<br></br>
							<li>
								<b>Phone:</b> {membershipUser.phone}
							</li>
							<br></br>
							<li>
								<b>Address 1:</b> {membershipUser.address1}
							</li>
							<br></br>
							<li>
								<b>Address 2:</b> {membershipUser.address2}
							</li>
							<br></br>
							<li>
								<b>City:</b> {membershipUser.city}
							</li>
							<br></br>
							<li>
								<b>State:</b> {membershipUser.state ? membershipUser.state.name:""}
							</li>
							<br></br>
							<li>
								<b>Zip:</b> {membershipUser.zip}
							</li>
						</ul>
					</div>
                        <div className="form-group col-md-6 col-lg-6">
                            <div className="row">
						        {membershipUser.membershipId == 0 ? [] :
						        (this.props.membershipUsersDetails.map((membershipUser) =>
							        <div className="col-md-12">
								        <h3 className="highlight">{membershipUser.organizationName}</h3>
								        <ul>
									        <li><b>Role:</b> { membershipUser.pending ? "Pending" : membershipUser.invitationType }</li>
									        <br></br>
									        <li><b>Membership ID:</b> {membershipUser.membershipId}</li>
									        <br></br>
									        <li><b>Renewal Date:</b> {membershipUser.renewalDate.substring(0,10).replace('/-/g', '/')}</li>
									        <br></br>
									        <li><b>Type:</b> {membershipUser.membershipType.description}</li>
									        <br></br>
									        <li><b>Description</b>: {membershipUser.membershipPackage.description}</li>
									        <br></br>
								        </ul>
								        <br></br>
								        <h2></h2>
							        </div>
                                    ))}
                            </div>
						</div>
					{this.props.userCommittees.length > 0?
					<div className="form-group col-md-6 col-lg-6">
                            <div className="row">
							<h2></h2>
							<h3 className="main-title">User Committees</h3>
						        {(this.props.userCommittees.map((userCommittee) =>
							        <div className="col-md-12">
								        <h3 className="highlight">{userCommittee.committeeName}</h3>
								        <ul>
									        <li><b>Position Name:</b> {userCommittee.positionName}</li>
									        <br></br>
									        <li><b>Position Ranking:</b> {userCommittee.positionRanking}</li>
									        <br></br>
								        </ul>
								        <br></br>
							        </div>
                                    ))}
                            </div>
					</div>
					:""}
					<DialogActionsBar>
						<div className="footer">
							<div className="form-group">
								<button className="admin-k-button">
									<span>DONE</span>
								</button>
							</div>
						</div>
					</DialogActionsBar>
				</form>}
			</Dialog>
		);
	}
}

function mapStateToProps(state) {
	console.log(state)
	return {
		common: state.common,
		membershipUsersDetails: state.membershipUser.membershipUsersDetails,
		userCommittees: state.accountDetails.userCommittees,
	};
}

export default connect(mapStateToProps, { fetchStates, fetchMembershipUsersByUser,getUserCommittees })(MembershipUserForm);